// src/services/api.js
// Semua komunikasi dengan backend ada di sini

const BASE_URL = '/api';

// ============================================
// HELPER — Fetch dengan token otomatis
// ============================================
async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem('erp_token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  };

  const response = await fetch(`${BASE_URL}${endpoint}`, config);
  const data     = await response.json();

  // Kalau token expired → logout otomatis
  if (response.status === 403) {
    localStorage.removeItem('erp_token');
    localStorage.removeItem('erp_user');
    window.location.href = '/';
    return;
  }

  return { ok: response.ok, status: response.status, data };
}

// ============================================
// AUTH API
// ============================================
export const authAPI = {

  login: async (username, password, divisi) => {
    return await apiFetch('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password, divisi }),
    });
  },


  register: async (nama, username, no_hp, password, divisi) => {
    return await apiFetch('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ nama, username, no_hp, password, divisi }),
    });
  },

  getProfile: async () => {
    return await apiFetch('/auth/profile');
  },

  gantiPassword: async (passwordLama, passwordBaru) => {
    return await apiFetch('/auth/password', {
      method: 'PUT',
      body: JSON.stringify({ passwordLama, passwordBaru }),
    });
  },

};

// ============================================
// PENGADAAN API
// ============================================
export const pengadaanAPI = {

  // PR
  getAllPR: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/pengadaan/pr${query ? '?'+query : ''}`);
  },

  getPRById: async (id) => {
    return await apiFetch(`/pengadaan/pr/${id}`);
  },

  createPR: async (data) => {
    return await apiFetch('/pengadaan/pr', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updatePR: async (id, data) => {
    return await apiFetch(`/pengadaan/pr/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deletePR: async (id) => {
    return await apiFetch(`/pengadaan/pr/${id}`, {
      method: 'DELETE',
    });
  },

  approvePR: async (id, aksi) => {
    return await apiFetch(`/pengadaan/pr/${id}/approval`, {
      method: 'PUT',
      body: JSON.stringify({ aksi }),
    });
  },

  // PO
  getAllPO: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/pengadaan/po${query ? '?'+query : ''}`);
  },

  createPO: async (data) => {
    return await apiFetch('/pengadaan/po', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  approvePO: async (id, aksi) => {
    return await apiFetch(`/pengadaan/po/${id}/approval`, {
      method: 'PUT',
      body: JSON.stringify({ aksi }),
    });
  },

  // GR
  getAllGR: async () => {
    return await apiFetch('/pengadaan/gr');
  },

  createGR: async (data) => {
    return await apiFetch('/pengadaan/gr', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  
  // DPH
  getAllDPH: async () => {
  return await apiFetch('/pengadaan/dph');
  },

  createDPH: async (data) => {
    return await apiFetch('/pengadaan/dph', {
    method: 'POST',
    body: JSON.stringify(data),
    });
  },

};

// ============================================
// KEUANGAN API
// ============================================
export const keuanganAPI = {

  // Pengeluaran Anggaran
  getAllPengeluaranAnggaran: async (params={}) => {
  const q = new URLSearchParams(params).toString();
  return await apiFetch(`/keuangan/pengeluaran-anggaran${q?'?'+q:''}`);
  },
  createPengeluaranAnggaran: async (data) => apiFetch('/keuangan/pengeluaran-anggaran', { method:'POST', body: JSON.stringify(data) }),

  // Kas & Bank
  getAllKasBank: async () => {
    return await apiFetch('/keuangan/kas-bank');
  },

  getTransaksi: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/keuangan/transaksi${query ? '?'+query : ''}`);
  },

  createTransaksi: async (data) => {
    return await apiFetch('/keuangan/transaksi', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Invoice
  getAllInvoice: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/keuangan/invoice${query ? '?'+query : ''}`);
  },

  createInvoice: async (data) => {
    return await apiFetch('/keuangan/invoice', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  bayarInvoice: async (id, data) => {
    return await apiFetch(`/keuangan/invoice/${id}/bayar`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Anggaran
  getAllAnggaran: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/keuangan/anggaran${query ? '?'+query : ''}`);
  },

  createAnggaran: async (data) => {
    return await apiFetch('/keuangan/anggaran', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Laporan
  getLaporanRingkasan: async () => {
    return await apiFetch('/keuangan/laporan/ringkasan');
  },

  // Pembayaran Vendor
  getPOApproved: async () => {
    return await apiFetch('/keuangan/po-approved');
  },

  getAllPembayaranVendor: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/keuangan/pembayaran-vendor${query ? '?'+query : ''}`);
  },

  createPembayaranVendor: async (data) => {
    return await apiFetch('/keuangan/pembayaran-vendor', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Pengajuan Kas
  getAllPengajuanKas: async (params={}) => {
    const q = new URLSearchParams(params).toString();
    return await apiFetch(`/keuangan/pengajuan-kas${q?'?'+q:''}`);
    },
  getPengajuanSiapLaporan: async () => apiFetch('/keuangan/pengajuan-kas/siap-laporan'),
  createPengajuanKas: async (data) => apiFetch('/keuangan/pengajuan-kas', { method:'POST', body: JSON.stringify(data) }),
  approvePengajuanKas: async (id, aksi) => apiFetch(`/keuangan/pengajuan-kas/${id}/approval`, { method:'PUT', body: JSON.stringify({ aksi }) }),
  cairkanPengajuanKas: async (id, data) => apiFetch(`/keuangan/pengajuan-kas/${id}/cairkan`, { method:'PUT', body: JSON.stringify(data) }),

  // Laporan Penggunaan Kas
  getAllLaporanKas: async () => apiFetch('/keuangan/laporan-kas'),
  createLaporanKas: async (data) => apiFetch('/keuangan/laporan-kas', { method:'POST', body: JSON.stringify(data) }),
  approveLaporanKas: async (id, kas_bank_id) => apiFetch(`/keuangan/laporan-kas/${id}/approval`, { method:'PUT', body: JSON.stringify({ kas_bank_id }) }),

};

// ============================================
// PROYEK API
// ============================================
export const proyekAPI = {

  getAll: async () => {
    return await apiFetch('/proyek');
  },

  getById: async (id) => {
    return await apiFetch(`/proyek/${id}`);
  },

  create: async (data) => {
    return await apiFetch('/proyek', { method: 'POST', body: JSON.stringify(data) });
  },

  update: async (id, data) => {
    return await apiFetch(`/proyek/${id}`, { method: 'PUT', body: JSON.stringify(data) });
  },

  createRAB: async (data) => {
    return await apiFetch('/proyek/rab', { method: 'POST', body: JSON.stringify(data) });
  },

  updateRealisasiRAB: async (id, realisasi_vol) => {
    return await apiFetch(`/proyek/rab/${id}/realisasi`, { method: 'PUT', body: JSON.stringify({ realisasi_vol }) });
  },

  createMilestone: async (data) => {
    return await apiFetch('/proyek/milestone', { method: 'POST', body: JSON.stringify(data) });
  },

  updateMilestone: async (id, progress) => {
    return await apiFetch(`/proyek/milestone/${id}`, { method: 'PUT', body: JSON.stringify({ progress }) });
  },

  createDokumen: async (data) => {
    return await apiFetch('/proyek/dokumen', { method: 'POST', body: JSON.stringify(data) });
  },

  getLaporan: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return await apiFetch(`/proyek/laporan/all${query ? '?'+query : ''}`);
  },

  createLaporan: async (data) => {
    return await apiFetch('/proyek/laporan', { method: 'POST', body: JSON.stringify(data) });
  },

  bulkImport: async (items) => apiFetch('/proyek/bulk-import', { method:'POST', body: JSON.stringify({ items }) }),

  delete: async (id) => apiFetch(`/proyek/${id}`, { method:'DELETE' }),
};

// ============================================
// USER MANAGEMENT API
// ============================================
export const userAPI = {
  getAllModules: async () => apiFetch('/users/modules'),
  getAll:        async () => apiFetch('/users'),
  getTabKeuangan:    async (id) => apiFetch(`/users/${id}/akses-tab-keuangan`),
  updateTabKeuangan: async (id, tabs) => apiFetch(`/users/${id}/akses-tab-keuangan`, { method:'PUT', body: JSON.stringify({ tabs }) }),
  getById:       async (id) => apiFetch(`/users/${id}`),
  create:        async (data) => apiFetch('/users', { method:'POST', body: JSON.stringify(data) }),
  update:        async (id, data) => apiFetch(`/users/${id}`, { method:'PUT', body: JSON.stringify(data) }),
  resetPassword: async (id, password_baru) => apiFetch(`/users/${id}/password`, { method:'PUT', body: JSON.stringify({ password_baru }) }),
  updateAkses:   async (id, akses) => apiFetch(`/users/${id}/akses`, { method:'PUT', body: JSON.stringify({ akses }) }),
  nonaktifkan:   async (id) => apiFetch(`/users/${id}/nonaktifkan`, { method:'PUT' }),
  aktifkan:      async (id) => apiFetch(`/users/${id}/aktifkan`, { method:'PUT' }),
  hapus:         async (id) => apiFetch(`/users/${id}`, { method:'DELETE' }),
};

// ============================================
// GUDANG API
// ============================================
export const gudangAPI = {
  getAllGudang: async () => apiFetch('/gudang/gudang'),
  createGudang: async (data) => apiFetch('/gudang/gudang', { method:'POST', body: JSON.stringify(data) }),
  updateGudang: async (id, data) => apiFetch(`/gudang/gudang/${id}`, { method:'PUT', body: JSON.stringify(data) }),

  getAllBarang: async () => apiFetch('/gudang/barang'),
  createBarang: async (data) => apiFetch('/gudang/barang', { method:'POST', body: JSON.stringify(data) }),
  bulkImportBarang: async (items) => apiFetch('/gudang/barang/bulk-import', { method:'POST', body: JSON.stringify({ items }) }),
  updateBarang: async (id, data) => apiFetch(`/gudang/barang/${id}`, { method:'PUT', body: JSON.stringify(data) }),
  deleteBarang: async (id) => apiFetch(`/gudang/barang/${id}`, { method:'DELETE' }),


  getStok: async (params={}) => {
    const q = new URLSearchParams(params).toString();
    return await apiFetch(`/gudang/stok${q?'?'+q:''}`);
  },

  getBAPBBelumMasuk: async () => apiFetch('/gudang/bapb-belum-masuk'),
  getAllBarangMasuk: async (params={}) => {
    const q = new URLSearchParams(params).toString();
    return await apiFetch(`/gudang/masuk${q?'?'+q:''}`);
  },
  createBarangMasuk: async (data) => apiFetch('/gudang/masuk', { method:'POST', body: JSON.stringify(data) }),

  getRABUntukKeluar: async (proyek_id) => apiFetch(`/gudang/rab-untuk-keluar?proyek_id=${proyek_id}`),
  getAllBarangKeluar: async (params={}) => {
    const q = new URLSearchParams(params).toString();
    return await apiFetch(`/gudang/keluar${q?'?'+q:''}`);
  },
  createBarangKeluar: async (data) => apiFetch('/gudang/keluar', { method:'POST', body: JSON.stringify(data) }),
};


// ============================================
// UPLOAD API
// ============================================
export const uploadAPI = {
  uploadLaporanKas: async (files) => {
    const token = localStorage.getItem('erp_token');
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));

    const response = await fetch(`${BASE_URL}/upload/laporan-kas`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }, // JANGAN set Content-Type manual untuk FormData
      body: formData,
    });
    const data = await response.json();
    return { ok: response.ok, status: response.status, data };
  },

  uploadBAPB: async (files) => {
  const token = localStorage.getItem('erp_token');
  const formData = new FormData();
  files.forEach(f => formData.append('files', f));
  const response = await fetch(`${BASE_URL}/upload/bapb`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
    body: formData,
  });
  const data = await response.json();
  return { ok: response.ok, status: response.status, data };
  },
};

// ============================================
// MASTER DATA API
// ============================================
export const masterAPI = {
  getAllVendor: async () => apiFetch('/master/vendor'),
  createVendor: async (data) => apiFetch('/master/vendor', { method:'POST', body: JSON.stringify(data) }),
  updateVendor: async (id, data) => apiFetch(`/master/vendor/${id}`, { method:'PUT', body: JSON.stringify(data) }),
  bulkImportVendor: async (items) => apiFetch('/master/vendor/bulk-import', { method:'POST', body: JSON.stringify({ items }) }),
  deleteVendor: async (id) => apiFetch(`/master/vendor/${id}`, { method:'DELETE' }),
  
  getAllKlien: async () => apiFetch('/master/klien'),
  createKlien: async (data) => apiFetch('/master/klien', { method:'POST', body: JSON.stringify(data) }),
  updateKlien: async (id, data) => apiFetch(`/master/klien/${id}`, { method:'PUT', body: JSON.stringify(data) }),
  bulkImportKlien: async (items) => apiFetch('/master/klien/bulk-import', { method:'POST', body: JSON.stringify({ items }) }),
  deleteKlien: async (id) => apiFetch(`/master/klien/${id}`, { method:'DELETE' }),

};


// ============================================
// ABSENSI API
// ============================================
export const absensiAPI = {
  getAllKaryawan:      async () => apiFetch('/absensi/karyawan'),
  getAllPekerjaHarian: async () => apiFetch('/absensi/pekerja-harian'),
  createPekerjaHarian: async (data) => apiFetch('/absensi/pekerja-harian', { method:'POST', body: JSON.stringify(data) }),
  updatePekerjaHarian: async (id, data) => apiFetch(`/absensi/pekerja-harian/${id}`, { method:'PUT', body: JSON.stringify(data) }),
  nonaktifkanPekerjaHarian: async (id) => apiFetch(`/absensi/pekerja-harian/${id}/nonaktifkan`, { method:'PUT' }),

  getAbsensiTanggal: async (tanggal) => apiFetch(`/absensi/tanggal?tanggal=${tanggal}`),
  simpanAbsensi:     async (data) => apiFetch('/absensi/simpan', { method:'POST', body: JSON.stringify(data) }),
  getRekap:          async (params={}) => {
    const q = new URLSearchParams(params).toString();
    return apiFetch(`/absensi/rekap${q?'?'+q:''}`);
  },
};



export default apiFetch;